module.exports = __webpack_public_path__ + "static/media/41.f33db437.png";